module.exports = __webpack_public_path__ + "img/bank_accounts.89ce1b32.svg";